// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button{color:var(--accent-color);font-size:0.9em;display:block;margin-top:5px}\n", ""]);
// Exports
module.exports = exports;
